import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FiArrowRight } from "react-icons/fi";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import FlowField from "../components/forms/FlowField";
import { CREATION_STEPS } from "../components/options/OptionParts";
import { addToCart } from "../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import { isAssociation } from "../utils/creationFlow";
import "./styles/flow-form.css";

const validationSchema = Yup.object({
  firstname: Yup.string().trim().required("Le prénom est requis"),
  lastname: Yup.string().trim().required("Le nom est requis"),
});

function ManagerName() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  const association =
    cart.from === "creation" && isAssociation(cart.businessType);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleSubmit = async ({ firstname, lastname }) => {
    await dispatch(
      addToCart({
        managerFirstname: firstname.trim(),
        managerLastname: lastname.trim(),
        managerName: `${firstname.trim()} ${lastname.trim()}`,
      }),
    );

    navigate(association ? "/business-name" : "/owner-marital-status");
  };

  return (
    <div className="flow-form-page">
      <Header />
      <ProgressBar steps={CREATION_STEPS} currentStep="Propriétaire" />

      <header className="flow-form-header">
        <h1 className="flow-form-title">
          Qui sera le <span>{association ? "président" : "gérant"}</span> ?
        </h1>
        <p className="flow-form-lead">
          {association
            ? "Indiquez le nom de la personne qui présidera l'association."
            : "Indiquez le nom de la personne qui dirigera l'entreprise."}
        </p>
      </header>

      <Formik
        initialValues={{
          firstname: cart.managerFirstname || "",
          lastname: cart.managerLastname || "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="flow-form" noValidate>
            <div className="flow-form-row">
              <FlowField
                name="firstname"
                label="Prénom"
                placeholder="Ex. : Marie"
                autoComplete="given-name"
              />
              <FlowField
                name="lastname"
                label="Nom"
                placeholder="Ex. : Ngo Biyong"
                autoComplete="family-name"
              />
            </div>

            <div className="flow-actions">
              <button
                type="submit"
                className="flow-submit"
                disabled={isSubmitting}
              >
                Continuer <FiArrowRight aria-hidden="true" />
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ManagerName;
